import {
    TheWestSection,
    FlyoutNavStateProvider,
    ScrollToTopOnNav,
    FeatureToggle,
    TheWestLiveProvider,
    DebugAdUnitsList,
    CookieConsentManager,
    UserAnalytics,
} from '@news-mono/component-library'
import {
    NavEvent,
    AdEvent,
    UserAuthEvents,
    SubscribeEvent,
    CookieConsentEvent,
    RadioEvent,
    BaseClientConfig,
    AdState,
    AdDefinition,
    Product,
} from '@news-mono/web-common'
import H from 'history'
import React from 'react'
import { layout } from './App.routing'
import { BaseTheWest } from './BaseTheWest/BaseTheWest'
import { StyledSite } from './Site.styled'

export interface SiteProps {
    pageContents: React.ReactElement<any>
    pageType: string
    additionalPageProperties: object
    location: H.Location
    onEvent: (
        event:
            | NavEvent
            | AdEvent
            | UserAuthEvents
            | SubscribeEvent
            | CookieConsentEvent
            | RadioEvent,
    ) => void
    config: BaseClientConfig
    ads: AdState | undefined
    section: TheWestSection
}

export interface State {
    mobileNavExpanded: boolean
}

const headerUnit: AdDefinition = {
    id: 'header',
    size: 'leaderboard768Above',
    isSitewideAd: true,
}

const stickyFooterUnit: AdDefinition = {
    id: 'sticky-footer',
    size: 'mobileLeaderboard',
}

export const siteAds: AdDefinition[] = [headerUnit, stickyFooterUnit]

// This emulates the ads rendered above the content in this file for the ad-diagnostics page
export const headerCompositions = [
    layout.composition({
        type: 'thor',
        props: {},
        contentAreas: {
            main: [
                layout.component({
                    type: 'ad-unit',
                    props: {
                        noticePosition: 'top-right',
                        slot: headerUnit,
                    },
                }),
            ],
        },
    }),
]

export const footerCompositions = [
    layout.composition({
        type: 'thor',
        props: {},
        contentAreas: {
            main: [
                layout.component({
                    type: 'ad-unit',
                    props: {
                        noticePosition: 'below-center',
                        slot: stickyFooterUnit,
                    },
                }),
            ],
        },
    }),
]

export const Site: React.FC<SiteProps> = ({
    config,
    location,
    ads,
    section,
    onEvent,
    pageContents,
    additionalPageProperties,
    pageType,
}) => {
    const baseWest = (
        <FlyoutNavStateProvider>
            {(flyOutProps) => (
                <BaseTheWest
                    additionalPageProperties={additionalPageProperties}
                    ads={ads}
                    config={config}
                    flyOutProps={flyOutProps}
                    location={location}
                    onEvent={onEvent}
                    pageContents={pageContents}
                    pageType={pageType}
                    product={Product.TheWest}
                    section={section}
                />
            )}
        </FlyoutNavStateProvider>
    )

    return (
        <React.Fragment>
            <UserAnalytics />
            <StyledSite>
                <ScrollToTopOnNav />

                <FeatureToggle
                    feature="the-west-live"
                    on={() => (
                        <TheWestLiveProvider
                            stationId={config.theWestLiveStationId}
                            onEvent={onEvent}
                        >
                            {baseWest}
                        </TheWestLiveProvider>
                    )}
                    off={() => baseWest}
                />
                <FeatureToggle
                    feature="debug-ads"
                    on={() => (
                        <DebugAdUnitsList
                            ads={ads}
                            pathname={location.pathname}
                        />
                    )}
                />
            </StyledSite>
            <FeatureToggle
                feature="cookie-consent"
                on={() => <CookieConsentManager onEvent={onEvent} />}
            />
        </React.Fragment>
    )
}
Site.displayName = 'Site'
